import { render, staticRenderFns } from "./FormReceiptBlock.vue?vue&type=template&id=65c3bb1b"
import script from "./FormReceiptBlock.vue?vue&type=script&lang=js"
export * from "./FormReceiptBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports